<template>
  <div>
    <div style="margin-top: 30px;">
      <h1 style="display: inline">{{ $t("booking.menu.mapping") }}</h1>
    </div>

    <booking-menu />

    <v-row />

    <v-card-title>
      <v-row>
        <v-col md="3" sm="5" cols="12">
          <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
        </v-col>
      </v-row>
    </v-card-title>

    <v-dialog max-width="500px" v-model="dialog">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-text-field :label="$t('booking.dateShort')" :value="formatDateView(dialogBooking.creation_date)" filled readonly />
          <v-text-field :label="$t('booking.other.serviceName')" filled readonly v-model="dialogBooking.type" />
          <v-text-field
            :label="$t('booking.numberShort')"
            filled
            readonly
            :value="
              dialogBooking.is_cancelled === 1 ? dialogBooking.reservation_number + ' (' + $t('booking.canceled') + ')' : dialogBooking.reservation_number
            "
          />
          <v-text-field :label="$t('booking.passenger')" filled readonly v-model="dialogBooking.passengers" style="text-transform: capitalize" />
          <v-text-field :label="$t('booking.orderingPerson')" filled readonly v-model="dialogBooking.orderingPerson" />
          <v-text-field :label="$t('booking.price')" :value="dialogBooking.total_amount" filled readonly suffix="PLN" />
          <v-autocomplete :items="formattedAvailableUsers" :label="$t('booking.assignedPersons')" multiple outlined v-model="dialogBooking.assignedPersons" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
      :custom-filter="filterOverAllProperty"
      :headers="headers"
      :items="bookings"
      :search="search"
      :sort-by="pagination.sortBy"
      :sort-desc.sync="pagination.descending"
    >
      <template #item="props">
        <tr>
          <td class="">{{ formatDateView(props.item.creation_date) }}</td>
          <td>{{ props.item.type }}</td>
          <td>
            {{ props.item.reservation_number }}

            <v-chip label outlined small style="color: #FFE3F3; background-color: #ff99d0 !important;" v-if="props.item.is_cancelled === 1"
              >{{ $t("booking.canceled") }}
            </v-chip>
          </td>
          <td style="text-transform: capitalize">{{ props.item.passengers }}</td>
          <td>{{ props.item.orderingPerson }}</td>
          <td>
            <span v-for="userId of props.item.assignedPersons" :key="userId">
              {{ availableUsers.find(v => v.id === userId).name }} {{ availableUsers.find(v => v.id === userId).surname }} (<b>
                {{ availableUsers.find(v => v.id === userId).login }}</b
              >) <br />
            </span>
          </td>
          <td class="datatable-total-amount">
            {{ props.item.total_amount }}
            <template v-if="props.item.total_amount != null">PLN</template>
          </td>
          <td>
            <v-row>
              <v-tooltip bottom>
                {{ $t("booking.assignUsers") }}
                <template #activator="{on}">
                  <v-btn @click="openDialog(props.item)" icon v-on="on">
                    <v-icon>fa-user-tag</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
              <v-tooltip bottom>
                {{ $t("booking.parseUsers") }}
                <template #activator="{on}">
                  <v-btn @click="parseUsers(props.item.id)" icon v-on="on">
                    <v-icon>fa-users-cog</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import BookingMenu from "../../components/Booking/BookingMenu.vue";
import formatDateView from "../../repository/fotmatDateView";
import filterOverAllProperty from "../../repository/filterOverAllProperty";

export default {
  name: "BookingMappingView",
  components: { BookingMenu },
  data: () => ({
    search: "",
    bookings: [],
    availableUsers: [],
    assignedPersons: [],
    dialog: false,
    dialogBooking: {
      assignedPersons: [],
      canceled: 0,
      creation_date: "",
      id: null,
      orderingPerson: "",
      passengers: "",
      reservation_number: "",
      total_amount: null,
      type: ""
    },
    pagination: {
      sortBy: "creation_date",
      descending: true
    }
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("booking.dateShort"), value: "creation_date" },
        { text: this.$t("booking.other.serviceName"), value: "name" },
        { text: this.$t("booking.numberShort"), value: "reservation_number" },
        {
          text: this.$t("booking.passenger"),
          value: "client_name",
          sortable: false
        },
        {
          text: this.$t("booking.orderingPerson"),
          value: "client_surname",
          sortable: false
        },
        { text: this.$t("booking.assignedPersons"), value: "total_amount" },
        {
          text: this.$t("booking.price"),
          value: "total_amount",
          sortable: false
        },
        { text: "", value: "actions", sortable: false }
      ];
    },
    formattedAvailableUsers() {
      let result = [];
      for (let user of this.availableUsers) {
        result.push({ value: user.id, text: user.name + " " + user.surname });
      }
      return result;
    }
  },
  methods: {
    openDialog(item) {
      this.dialogBooking = JSON.parse(JSON.stringify(item));
      this.dialog = true;
    },
    formatDateView: formatDateView,
    filterOverAllProperty: filterOverAllProperty,
    save() {
      this.axios
        .post("booking/save-mapping", {
          booking_id: this.dialogBooking.id,
          user_ids: this.dialogBooking.assignedPersons
        })
        .then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
          this.load();
          this.dialog = false;
        });
    },
    parseUsers(bookingId) {
      this.axios.post("booking/auto-map", { booking_id: bookingId }).then(() => {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
        this.load();
      });
    },
    load() {
      this.axios.get("booking/get-mapping").then(resp => {
        this.bookings = resp.data;
      });
    }
  },
  created() {
    this.load();
    this.axios.get("booking/available-users").then(resp => {
      this.availableUsers = resp.data;
    });
  }
};
</script>

<style scoped></style>
